import xhr from './../../../utils/xhr';

let api = {

    getTableDataCompanyArticlesPage: function(url, pageNumber, pageSize, sortBy, direction, urlParams, dataStore, verb, requestPayload) {
        if (dataStore!=null) {
            return Promise.resolve({body:dataStore});
        }

        let queryParams = api.splitQueryParams(url);
        let newUrl = api.getRootUrl(url);

        queryParams = urlParams ? Object.assign(queryParams, urlParams) : queryParams;
        queryParams = api.buildQueryParamsCompanyArticlesPage(pageNumber, pageSize, sortBy, direction, queryParams);

        return xhr.post({
            url: newUrl,
            queryParams: queryParams,
            data: requestPayload ? requestPayload : null
        });

    },

    buildQueryParamsCompanyArticlesPage: function(pageNumber, pageSize, sortBy, direction, urlParams) {
        let parsedUrlParams = Object.assign({}, urlParams);

        return Object.assign(
            {
                pageNumber: pageNumber,
                pageSize: pageSize,
                sortBy: sortBy,
                direction: direction
            },
            parsedUrlParams
        );
    },

    splitQueryParams: function(url) {
        let index = url.indexOf('?');
        if (index < 0) return {};
        let query = url.substr(index + 1),
            queryParts = query.split('&'),
            queryParams = {};

        for (let i = 0; i < queryParts.length; i++) {
            let keyValuePair = queryParts[i].split('=');

            if (keyValuePair.length === 2) {
                queryParams[keyValuePair[0]] = decodeURIComponent(keyValuePair[1]);
            } else {
                queryParams[keyValuePair[0]] = null;
            }
        }

        return queryParams;
    },

    getRootUrl: function(url) {
        if (url.indexOf('?')>0) {
            return url.substr(0, url.indexOf('?') + 1);
        } else {
            return url;
        }
    },
};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/reusable/CustomTableBody/redux/CustomTableBodyPostParamsWrapper.api.js